import { createFileRoute } from "@tanstack/react-router";
import Wallet from "@/pages/Wallet";
import { MainLayout } from "@/components/layout/MainLayout";

export const Route = createFileRoute("/wallet")({
  head: () => ({
    meta: [
      { title: "Credit Wallet | Statlign" },
      { name: "description", content: "Your Statlign credits — spend credits to reveal predictions." },
      { property: "og:title", content: "Credit Wallet | Statlign" },
      { property: "og:type", content: "website" },
      { property: "og:description", content: "Your Statlign credits — spend credits to reveal predictions." },
      { name: "twitter:title", content: "Credit Wallet | Statlign" },
      { name: "twitter:description", content: "Your Statlign credits — spend credits to reveal predictions." },
      { name: "robots", content: "noindex, nofollow" },
    ],
  }),
  component: () => (
    <MainLayout>
      <Wallet />
    </MainLayout>
  ),
});
